__turbopack_context__.v({
  "buttonBox": "NewsletterV2-module__6LkiBq__buttonBox",
  "checkBox": "NewsletterV2-module__6LkiBq__checkBox",
  "groupButton": "NewsletterV2-module__6LkiBq__groupButton",
  "headerNewsletter": "NewsletterV2-module__6LkiBq__headerNewsletter",
  "inputBox": "NewsletterV2-module__6LkiBq__inputBox",
  "modal": "NewsletterV2-module__6LkiBq__modal",
  "msgBlock": "NewsletterV2-module__6LkiBq__msgBlock",
  "newLetterContainer": "NewsletterV2-module__6LkiBq__newLetterContainer",
  "newsLettetPb": "NewsletterV2-module__6LkiBq__newsLettetPb",
  "newsletter-modal-content": "NewsletterV2-module__6LkiBq__newsletter-modal-content",
  "newsletter-modal-header": "NewsletterV2-module__6LkiBq__newsletter-modal-header",
  "newsletterAddImage": "NewsletterV2-module__6LkiBq__newsletterAddImage",
});
